import noUiSlider from 'nouislider'
import { component } from 'picoapp'
import { formatMoney } from '../lib/currency'

export default component((node) => {
    const min = node.querySelector('input[name="filter.v.price.gte"]')
    const max = node.querySelector('input[name="filter.v.price.lte"]')
    const minLabel = node.querySelector('[data-min]')
    const maxLabel = node.querySelector('[data-max]')

    const range = noUiSlider.create(node.querySelector('[data-range]'), {
        start: [parseInt(min.value, 10), parseInt(max.value, 10)],
        step: 100,
        connect: true,
        range: {
            min: parseInt(min.min, 10),
            max: parseInt(max.max, 10),
        },
    })

    range.on('update', function (values) {
        const [minValue, maxValue] = values

        min.value = (Math.round(minValue) / 100).toString()
        max.value = (Math.round(maxValue) / 100).toString()

        minLabel.textContent = formatMoney(Math.round(minValue))
        maxLabel.textContent = formatMoney(Math.round(maxValue))
    })
})
